import { useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { gql } from '@apollo/client';

import { HomeContext } from '../Home.context';
import { Issue } from '../../../constants';
import config from '../../../config';
import { AUTH_KEY, AuthenticateUserResponse } from '../auth/Authentication.hooks';

export function useIsSupportMagazine(): null | boolean {
    const [isSupported, setIsSupported] = useState<null | boolean>(null);

    useEffect(() => {
        if (!config.app.auth.enabled) {
            setIsSupported(true);
            return;
        }


        if (config.app.auth.type === 'token' ||
            config.app.auth.type === 'cognito') {
            setTimeout(() => {
                if (localStorage.getItem(AUTH_KEY)) {
                    setIsSupported(true);
                } else {
                    setIsSupported(false);
                }
            }, 1000);
            return;
        }

        if (!localStorage.getItem('authenticated')) {
            return;
        }
        const userString = localStorage.getItem('user');
        if (userString === null) {
            window.location.href = '/';
            return;
        }
        const user: AuthenticateUserResponse = JSON.parse(userString);
        setIsSupported(user?.digitalAccess);
    }, []);
    return isSupported;
}

export function useSelectIssue(issues: Array<Issue>) {
    const [searchParams, setSearchParams] = useSearchParams();
    const { setSelectedIssue } = useContext(HomeContext);
    useEffect(() => {
        if (!issues.length) {
            return;
        }
        const updatedSearchParams = new URLSearchParams(
            searchParams.toString(),
        );
        updatedSearchParams.set('section', 'magazines');

        const id = updatedSearchParams.get('id');
        if (!id) {
            setSearchParams(updatedSearchParams.toString());
            return;
        }

        const filteredIssue = issues
            .filter((issue) => `${issue.id}` === `${id}`)
            .pop();

        if (filteredIssue) {
            setSelectedIssue(filteredIssue);
            updatedSearchParams.set('id', filteredIssue.id);
            setSearchParams(updatedSearchParams.toString());
            return;
        }

        setSelectedIssue(null);
        updatedSearchParams.set('id', '');
        updatedSearchParams.delete('id');

        setSearchParams(updatedSearchParams.toString());
    }, [searchParams, issues]);
}

export const GET_ISSUES = gql`
{
	issues{
		    id
            name
            description
            cover
            externalUrl
            price
            index
            slug
            currency
            data
            updated
            created
            releaseDate
            isPurchased
            isPaid

    }	
}
`

// TODO Use this to revert back features
export const HACK_GET_ISSUES = gql`
{
	issues{
		    id
            name
            description
            cover
            externalUrl
            price
            features
            index
            slug
            currency
            data
            updated
            created
            releaseDate
            isPurchased
            isPaid

    }	
}
`